module.exports = [{
      plugin: require('/home/aoki/Projects/personal/concurso-musical/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
